/**
 * @broadpaper/forme in the browser. Identical to the default entry but for how
 * the engine's WASM is instantiated — see `engine.browser.ts` for why that has
 * to differ, and for `setFormeWasm`.
 */
import { setEngineLoader, setFontFileReader } from "./api.js";
import { loadEngine, readFontFile, setFormeWasm } from "./engine.browser.js";

setEngineLoader(loadEngine);
setFontFileReader(readFontFile);

export { setFormeWasm };
export * from "./api.js";
